function asStr(x) {
  return String(x ?? "")
    .trim()
    .toLowerCase();
}

/**
 * Historische Whitelist für gespeicherte `preferredHomeApp`-Werte.
 * Die Wahl einer Start-App ist abgeschaltet: Login landet immer im Hub
 * (Ausnahme: Mannschaftsführer-Only → TeamDesk Kader).
 */
export const HOME_APP_OPTIONS = Object.freeze([
  "hub",
  "trainerstunden",
  "schleifchen",
  "matchmixer",
  "clubmeisterschaft",
  "medenspiele",
  "belegung",
  "winterdoppel",
  "kalender",
  "tennis-live",
  "minigames",
]);

export function normalizePreferredHomeApp(value) {
  const v = asStr(value);
  return HOME_APP_OPTIONS.includes(v) ? v : "hub";
}

export function canUsePreferredHomeApp(_appKey) {
  return false;
}

/** Browser-Event: Startseiten-Präferenz wurde geändert (Hub-Kachel oder Einstellungen). */
export const PREFERRED_HOME_CHANGED_EVENT = "tm:preferred-home-changed";

export function dispatchPreferredHomeChanged(preferredHomeApp) {
  if (typeof window === "undefined") return;
  const next = normalizePreferredHomeApp(preferredHomeApp);
  window.dispatchEvent(
    new CustomEvent(PREFERRED_HOME_CHANGED_EVENT, {
      detail: { preferredHomeApp: next },
    }),
  );
}

/** Liest preferredHomeApp synchron aus dem Settings-LocalStorage (Bootstrapping). */
export function readStoredPreferredHomeAppSync() {
  if (typeof window === "undefined") return "hub";
  try {
    const raw = window.localStorage.getItem("tm_user_settings");
    if (!raw) return "hub";
    const parsed = JSON.parse(raw);
    if (!parsed || typeof parsed !== "object") return "hub";
    return normalizePreferredHomeApp(
      parsed.preferredHomeApp || parsed.preferred_home_app,
    );
  } catch {
    return "hub";
  }
}

/**
 * Marketplace-Apps (ohne Hub-Plattform) für Home-Routing.
 * @param {unknown} allowedAppKeys
 * @returns {string[]}
 */
export function listMarketplaceHomeApps(allowedAppKeys = []) {
  const src = Array.isArray(allowedAppKeys) ? allowedAppKeys : [];
  const uniq = [];
  const seen = new Set();
  for (const raw of src) {
    const key = asStr(raw);
    if (!key || key === "hub" || seen.has(key)) continue;
    seen.add(key);
    uniq.push(key);
  }
  return uniq;
}

/**
 * Central home route resolution.
 *
 * Login landet im Hub (Kalender + App-Kacheln). Gespeicherte
 * `preferredHomeApp`-Werte (z. B. TrainingsDesk) werden ignoriert.
 *
 * Ausnahme: Mannschaftsführer-Only → TeamDesk Kader.
 */
export function resolveHomeRoute({
  preferredHomeApp: _preferredHomeApp,
  allowedAppKeys = [],
  isFamilyOnlyLogin = false, // eslint-disable-line no-unused-vars
  isTeamCaptainOnlyLogin = false,
} = {}) {
  const allowed = new Set(
    (Array.isArray(allowedAppKeys) ? allowedAppKeys : [])
      .map((k) => asStr(k))
      .filter(Boolean),
  );

  const marketplaceApps = listMarketplaceHomeApps([...allowed]);
  if (
    isTeamCaptainOnlyLogin &&
    (marketplaceApps.length === 0 || marketplaceApps.includes("medenspiele"))
  ) {
    return "medenspiele-kader";
  }

  return "hub";
}
